import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, filter, take, switchMap, tap, ignoreElements } from 'rxjs/operators';
import { environment } from './../../environments/environment';
import * as uuid from 'uuid';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private formDataURL = [environment.URL_UPLOAD_IMAGE]

  constructor(public authService: AuthService, private http: HttpClient, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.getJwtToken()) {
      request = this.addToken(request, this.authService.getJwtToken(), this.authService.getState());
    }
    return next.handle(request).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return this.handle401Error(request, next);
      } else {
        return throwError(error);
      }
    }));
  }

  private addToken(request: HttpRequest<any>, token: string, state: string) {
    console.log(request.url)
    let isFormData = false
    this.formDataURL.forEach(element => {
      if (request.url.indexOf(element) !== -1) {
        isFormData = true
      }
    });
    
    if (isFormData) {
      return request.clone({
        setHeaders: {
          'Authorization': `Bearer ${token}`,
          'x-req-transactionid':  uuid.v4(),
        }
      });
    } else if(request.url.includes('maps.googleapis.com/maps/api/geocode')){
      return request.clone({
        setHeaders: {
        }
      });
    } else {
      return request.clone({
        setHeaders: {
          'Content-Type': 'application/json', 'Authorization': `Bearer ${token}`, 'State': `${state}`,
          'x-req-transactionid':  uuid.v4(),
        }
      });
    }
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.authService.refreshToken().pipe(
        switchMap((token: any) => {
          if (token.code == 400) {
            console.log("TOKEN INVALID",token)
            this.router.navigate(["/error-page"], { queryParams: { state: this.authService.getState(), errorCode: '00' } }).then(() => {
              localStorage.clear();
              window.location.reload();
            });
          }
          this.isRefreshing = false;
          this.refreshTokenSubject.next(token.data.access_token);
          return next.handle(this.addToken(request, token.data.access_token, this.authService.getState()));
        }));

    } else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => {
          return next.handle(this.addToken(request, jwt, this.authService.getState()));
        }));
    }
  }




}